module.exports = __webpack_public_path__ + "img/sushi.41a8a616.jpg";